// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput-module_container_e61c5","tags":"SearchInput-module_tags_db0e1"};